export const cashInHistoryFilterState = (fleetId) => ({
  fleetId,
  startDate: null,
  endDate: null,
  searchKey: "",
  cashinChannel: "all",
  page: 1,
  perPage: 10,
});
